export default "__VITE_ASSET__DwS_mmt1__"